export interface imageZone {
  id: string | null;
  tempId?: string;
  examSheetPageId: string;
  percentX1: number;
  percentY1: number;
  percentX2: number;
  percentY2: number;
  orderNumber: number;
  pageNumber: number;
}

export interface imageZoneWithImgData {
  zone: imageZone;
  wholeImageData: Blob;
}

export enum zoneDragItemType {
  ZONE = 'zone',
}